<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Vet",
  path: "vet",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
